import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  useBaseOperateStore,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { h, ref } from 'vue';
import dayjs from 'dayjs';
import tpldraft from './tpldraft.vue';
import tpl from './tpl.vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const tpldraftRef = ref<InstanceType<typeof tpldraft>>();
const tplRef = ref<InstanceType<typeof tpl>>();

const baseOperateStore = useBaseOperateStore();

const addInitValue = {

};
const conditionsInitValue = {
};


const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    {
      name: 'name',
      label: '模板名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'templateId',
      label: '模板ID',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'currentVersion',
      label: '当前版本',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'description',
      label: '版本描述',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'extjsFormItems',
      label: 'extjs配置',
      type: 'textaera',
      width: 200,
      render: (scope: any) => h('div', {
        style: {
          maxWidth: '200px',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          lineHeight: '1.4',
        },
      }, String(scope?.row?.extjsFormItems || '')),
    },

    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },

  ]);
});

const currentWeappTpl = ref<any>();

const operates: any[] = baseOperateStore.operates?.find((item) => item.key === 'ADMIN_OPEN_WEAPP_TPL') ? [

  {
    key: 'tpldraft',
    name: '模板草稿',
    handler: useBaseAsync((row: any) => {
      tpldraftRef.value?.show();
    }),
  },

  {
    key: 'tpllist',
    name: '模板列表',
    handler: useBaseAsync((row: any) => {
      currentWeappTpl.value = row;
      tplRef.value?.show();
    }),
  },
] : [];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().weappTplApi.pageWeappTplweappTpl({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data?.map((item: any) => ({
        ...item,
        extjsFormItems: JSON.stringify(item.extjsFormItems),
      })) || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;


const addFun = useBaseAsync(async(_data: any) => {
  const data = { ..._data };
  if (data.extjsFormItems) {
    try {
      data.extjsFormItems = JSON.parse(data.extjsFormItems);
    } catch (error) {
      console.log(error);
      data.extjsFormItems = undefined;
    }
  }
  await useApi().weappTplApi.addWeappTplweappTpl(data);
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(_data: any) => {
  const data = { ..._data };
  if (data.extjsFormItems) {
    try {
      data.extjsFormItems = JSON.parse(data.extjsFormItems);
    } catch (error) {
      console.log(error);
      data.extjsFormItems = undefined;
    }
  }
  await useApi().weappTplApi.updateWeappTplweappTpl(data);
  ElMessage.success('修改成功');
});

const handleSetTpl = useBaseAsync(async(data: any) => {
  if (!currentWeappTpl.value) {
    return;
  }
  await useApi().weappTplApi.updateWeappTplweappTpl({
    ...currentWeappTpl.value,
    currentVersion: data.currentVersion,
    description: data.description,
    templateId: data.templateId,
  });
  ElMessage.success('设置成功');
  tableRef.value?.refresh();
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().weappTplApi.delWeappTplweappTpl(data.id);
  ElMessage.success('删除成功');
});


init();


return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "小程序模板",
      title: "小程序模板",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(baseOperateStore).operates?.find(item => item.key === 'ADD_WEAPP_TPL') && _unref(addFun),
      "on-delete": _unref(baseOperateStore).operates?.find(item => item.key === 'DEL_WEAPP_TPL') && _unref(deleteFun),
      "on-edit": _unref(baseOperateStore).operates?.find(item => item.key === 'EDIT_WEAPP_TPL') && _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: _unref(operates),
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading", "operates"]),
    _createVNode(tpldraft, {
      ref_key: "tpldraftRef",
      ref: tpldraftRef
    }, null, 512),
    _createVNode(tpl, {
      ref_key: "tplRef",
      ref: tplRef,
      onSetTpl: _unref(handleSetTpl)
    }, null, 8, ["onSetTpl"])
  ]))
}
}

})